import { home1_2pUrls } from '@/config/home1-2pManifest';
import { HOME_BROCHURE_SEGMENTS } from '@/config/homeBrochureSegments';

function segmentToTextItem(seg, imageIndex) {
	const isRepeat = imageIndex >= HOME_BROCHURE_SEGMENTS.length;
	return {
		type: 'text',
		key: 'text-' + seg.id + '-' + imageIndex,
		id: seg.id,
		title: seg.title,
		subtitle: isRepeat ? null : seg.subtitle,
		paragraphs: isRepeat
			? (seg.paragraphs && seg.paragraphs.length ? [seg.paragraphs[0]] : [])
			: seg.paragraphs || [],
		list: isRepeat ? [] : seg.list || [],
	};
}

/** 每张 1-2p 图前配一段文案（段落循环），保证图文 1:1 交替 */
export function buildBrochureItems() {
	const images = home1_2pUrls();
	const segments = HOME_BROCHURE_SEGMENTS;
	const items = [];
	images.forEach((url, i) => {
		const seg = segments[i % segments.length];
		items.push(segmentToTextItem(seg, i));
		items.push({
			type: 'image',
			key: 'img-' + i,
			url,
		});
	});
	return items;
}

/** 估算文案块高度（用于瀑布流分列） */
export function estimateTextBlockHeight(item, colWidth) {
	const charPerLine = Math.max(12, Math.floor(colWidth / 15));
	let lines = 2;
	if (item.title) lines += 1.2;
	if (item.subtitle) lines += 1;
	(item.paragraphs || []).forEach((p) => {
		lines += Math.ceil(p.length / charPerLine);
	});
	lines += (item.list || []).length * 1.1;
	return Math.max(120, Math.ceil(lines * 26) + 48);
}

function getItemHeight(item, colWidth, brochureDimensions, gap) {
	if (item.type === 'text') {
		return estimateTextBlockHeight(item, colWidth);
	}
	const dim = brochureDimensions[item.url];
	let h = colWidth * 0.75;
	if (dim && dim.w > 0) {
		h = (colWidth * dim.h) / dim.w;
	}
	return h;
}

/**
 * 按「文案 + 图片」成对放入当前最矮的列，列内始终图文相邻，避免同列连续多段文案或连续多图
 */
export function assignMasonryColumns(items, columnCount, colWidth, gap, brochureDimensions) {
	const count = columnCount;
	const cols = [];
	const heights = [];
	for (let i = 0; i < count; i++) {
		cols.push([]);
		heights.push(0);
	}

	for (let i = 0; i < items.length; i += 2) {
		const textItem = items[i];
		const imageItem = items[i + 1];
		if (!textItem || textItem.type !== 'text') continue;

		let pairHeight = getItemHeight(textItem, colWidth, brochureDimensions, gap) + gap;
		if (imageItem && imageItem.type === 'image') {
			pairHeight += getItemHeight(imageItem, colWidth, brochureDimensions, gap);
		}

		let bestCol = 0;
		for (let c = 1; c < count; c++) {
			if (heights[c] < heights[bestCol]) bestCol = c;
		}

		cols[bestCol].push(textItem);
		if (imageItem && imageItem.type === 'image') {
			cols[bestCol].push(imageItem);
		}
		heights[bestCol] += pairHeight + gap;
	}

	return cols;
}



// WEBPACK FOOTER //
// ./src/config/homeBrochureItems.js